import React, { useState,useEffect,useRef } from "react";
import {Checkbox,Divider,Select,Input,Form,Modal,Button, Spin} from "antd";
import { useDispatch} from "react-redux";
import { useNavigate } from "react-router-dom";
import { normalActionTypes, updateCommonErrorMessage, updateCommonSuccessMessage } from "@/redux/actions/weevilTrakAction";
import "./index.less";
import { weevilTrakRegister } from "@/util/http/WeevilTrak";


const SignUp = ()=>{
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [form] = Form.useForm();

    const [loadding,setLoading] = useState(false);


    const onFinish = async () => {
        setLoading(true);

        console.log("weeviltrak form a ",form.getFieldsValue());
        const resData = {
            firstName: form.getFieldValue("firstName"),
            lastName: form.getFieldValue("lastName"),
            email: form.getFieldValue("email"),
            password: form.getFieldValue("password"),
            confirm: form.getFieldValue("confirm"),
            timestamp: Date.now()
        };
        console.log("weeviltrak resData b ",resData);


        // return;
        try{
            const res=await weevilTrakRegister({
                firstName:resData.firstName,
                lastName:resData.lastName,
                // companyName:resData.companyName,
                email:resData.email,
                password:resData.password,
                confirmPassword: resData.confirm,
                timestamp: resData.timestamp
            });
            if(res.data){
                dispatch(updateCommonSuccessMessage("Registered successfully! Please log in with your new account."));
                navigate("/weeviltrak/login");
            }else{
                dispatch(updateCommonErrorMessage("Registration failed. Please try again."));

            }
        }
        catch(error:any){
            console.error("Registration error:", error);
            dispatch(updateCommonErrorMessage(error?.response?.data || "An error occurred during registration. Please try again."));
        }
        finally{
            setLoading(false);
        }

    };






    return(
        <div className="sign-up-style">
            <Spin
                tip="Loading..."
                size="large"
                spinning={loadding}

            >
                <Form
                    name="basic"
                    onFinish={onFinish}
                    form={form}
                    layout="vertical"
                    autoComplete="off"
                    style={{
                        marginTop: "50px",
                        padding: "20px 30px",
                        // border: "1px solid rgb(217, 217, 217)",
                        border: "1px solid rgb(89, 185, 72)",
                        borderRadius: "5px"
                    }}
                >
                    <Divider>
                        <p>Please Sign Up</p>
                    </Divider>

                    <Form.Item label="First Name" name="firstName"
                        rules={[{ required: true, message: "Please input your First Name!" }]}>
                        <Input placeholder="Input first name"
                            onChange={(e)=>{
                            // setFirstName(e.target.value);
                            }} />
                    </Form.Item>

                    <Form.Item
                        label="Last Name" name="lastName"
                        rules={[{ required: true, message: "Please input your Last Name!" }]}
                    >
                        <Input placeholder="Input last name"
                            onChange={(e)=>{
                            // setLastName(e.target.value);
                            }} />
                    </Form.Item>

                    <Form.Item
                        label="Email address" name="email"
                        rules={[
                            { required: true, message: "Please input your Email address!" },
                            {pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,message: "Incorrect format!",max:50}
                        ]}
                    >
                        <Input placeholder="Input email"
                            onChange={(e)=>{
                            // setEmail(e.target.value);
                            }} />
                    </Form.Item>

                    <Form.Item
                        label="Password" name="password"
                        rules={[{ required: true, message: "Please input your Password!" },
                            ()=>({
                                validator(_,value){
                                    const rx = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,18}$/;
                                    if (rx.test(value)){
                                        return Promise.resolve();
                                    }else{
                                        return Promise.reject(new Error(`The password strength is not enough. The password must contain letters and numbers,
                                    and the length is greater than 8 and less than 30`));
                                    }
                                }
                            })
                        ]}
                    >
                        <Input.Password placeholder="Input password"
                            onChange={(e)=>{
                            // setPassword(e.target.value);
                            }} />
                    </Form.Item>

                    <Form.Item
                        name="confirm"
                        label="Confirm Password"
                        dependencies={["password"]}
                        hasFeedback
                        rules={[
                            {
                                required: true,
                                message: "Please confirm your password!",
                            },
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue("password") === value) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject(new Error("The two passwords that you entered do not match!"));
                                },
                            }),
                        ]}
                    >
                        <Input.Password placeholder="Input password again" onChange={(e)=>{
                        // setConfirmPassword(e.target.value);
                        }} />
                    </Form.Item>


                    <Form.Item>
                        <Button type="primary"
                            htmlType="submit"
                            className="sign-up-button">
                        Sign Up
                        </Button>
                    </Form.Item>
                </Form>
            </Spin>

        </div>
    );
};

export default SignUp;